<template>
    <v-dialog v-model="viewFilters" width="1000px">
        <v-card>
            <v-card-title class="text-h5 grey lighten-2"> Filtres </v-card-title>
            <div class="filters-subtitle">Vous pouvez remplir un seul filtre ou plusieurs</div>
            <div class="filters-body">
                <search-panorama-general-filters
                    v-model="generalFilters"
                    :subjects="subjects"
                    :apenafs="apenafs"
                />
                <search-panorama-sub-filters
                    v-model="subFilters"
                    :insurers="insurers"
                    :subjects="subjects"
                    :annotationOptions="annotationOptions"
                    :displayedSubjectsByType="displayedSubjectsByType"
                    @change-tab="changeSelectedTab"
                    :selectedTab="selectedTab"
                />
            </div>
            <v-card-actions>
                <v-spacer></v-spacer>
                <action class="apply-button" @click="clearFilters" name="main" :nochevron="true">
                    Réinitialiser
                </action>
                <action class="apply-button" @click="updateFilters" name="main" :nochevron="true">
                    Appliquer
                </action>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from "src/bus/eventBus";
import SearchPanoramaGeneralFilters from "./SearchPanoramaGeneralFilters.vue";
import SearchPanoramaSubFilters from "./SearchPanoramaSubFilters.vue";

export default {
    props: [
        "value",
        "apenafs",
        "insurers",
        "annotationOptions",
        "displayedSubjectsByType",
        "subjects",
    ],
    components: {
        SearchPanoramaGeneralFilters,
        SearchPanoramaSubFilters,
    },
    data() {
        return {
            viewFilters: false,
            selectedTab: this.getInitialSelectedTab(),
            generalFilters: {
                apenafCode: this.value.apenafCode,
                shortTitle: this.value.shortTitle,
            },
            subFilters: {
                conventionFilters: {
                    excludedSubjects: this.value.excludedSubjects,
                },
                annotationFilters: {
                    insurerFilters: {
                        insurerCodes: this.value.insurerCodes,
                        guarantees: this.value.guarantees,
                        insuranceType: this.value.insuranceType,
                        des: this.value.des,
                        csps: this.value.csps,
                    },
                    ratesFilters: {
                        rateUnit: this.value.rateUnit,
                        rateValue: this.value.rateValue,
                        rateDistributionEmployer: this.value.rateDistributionEmployer,
                        rateDistributionEmployee: this.value.rateDistributionEmployee,
                    },
                    indemnityFilters: {
                        minimumSeniority: this.value.minimumSeniority,
                        ceiling: this.value.ceiling,
                        floor: this.value.floor,
                    },
                },
            },
        };
    },
    mounted() {
        EventBus.$on("openPanoramaFilters", viewFilters => {
            this.viewFilters = viewFilters;
        });
    },
    methods: {
        getInitialSelectedTab() {
            if (this.value.excludedSubjects) {
                return "convention";
            }
            return "annotation";
        },
        updateFilters() {
            let results = {
                ...this.generalFilters,
            };
            if (this.selectedTab === "convention") {
                results = {
                    ...results,
                    ...this.subFilters.conventionFilters,
                };
            }
            if (this.selectedTab === "annotation") {
                results = {
                    ...results,
                    ...this.subFilters.annotationFilters.insurerFilters,
                    ...this.subFilters.annotationFilters.ratesFilters,
                    ...this.subFilters.annotationFilters.indemnityFilters,
                };
            }
            this.$emit("input", results);
            EventBus.$emit("openPanoramaFilters", false);
        },
        changeSelectedTab(selectedTab) {
            this.selectedTab = selectedTab;
        },
        async clearFilters() {
            await EventBus.$emit("clearPanoramaFilters");
            this.updateFilters();
        },
    },
};
</script>

<style scoped lang="sass">
.filters-body
    margin: 16px 16px 0
    max-height: 730px
    overflow-y: auto
    padding-right: 16px
    padding-left: 16px

.filters-subtitle
    margin: 16px 24px 16px 32px
    color: grey

.apply-button
    margin: 0 16px
</style>
